/**
 * @generated SignedSource<<41cdbbbabd36b519902c919d73e22f08>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type bulkOperationsWrapper_issueNavigator_LoadBulkOpsCore$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly issueId: string;
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly totalIssueSearchResultCount?: number | null | undefined;
  readonly " $fragmentType": "bulkOperationsWrapper_issueNavigator_LoadBulkOpsCore";
};
export type bulkOperationsWrapper_issueNavigator_LoadBulkOpsCore$key = {
  readonly " $data"?: bulkOperationsWrapper_issueNavigator_LoadBulkOpsCore$data;
  readonly " $fragmentSpreads": FragmentRefs<"bulkOperationsWrapper_issueNavigator_LoadBulkOpsCore">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcbulkopsselectallrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "bulkOperationsWrapper_issueNavigator_LoadBulkOpsCore",
  "selections": [
    {
      "concreteType": "JiraIssueEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "JiraIssue",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "issueId"
            }
          ]
        }
      ]
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcbulkopsselectallrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "totalIssueSearchResultCount"
        }
      ]
    }
  ],
  "type": "JiraIssueConnection"
};

(node as any).hash = "de497a3f200446ddac4086da9a6ca3d9";

export default node;
